import { render, staticRenderFns } from "./ScaleControlo.vue?vue&type=template&id=73a9ccba&scoped=true"
import script from "./ScaleControlo.vue?vue&type=script&lang=js"
export * from "./ScaleControlo.vue?vue&type=script&lang=js"
import style0 from "./ScaleControlo.vue?vue&type=style&index=0&id=73a9ccba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a9ccba",
  null
  
)

export default component.exports